export const PeerConnection =
  typeof window !== 'undefined' &&
  (window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection);

export const IceCandidate =
  typeof window !== 'undefined' &&
  (window.RTCIceCandidate ||
    window.mozRTCIceCandidate ||
    window.RTCIceCandidate);

export const SessionDescription =
  typeof window !== 'undefined' &&
  (window.RTCSessionDescription ||
    window.mozRTCSessionDescription ||
    window.RTCSessionDescription);
